import React, { Component } from 'react';
import { Menu, MenuItem } from '@blueprintjs/core';


class MenuTripSearch extends Component {

    render() {
        const status = 'Complete,Noload,Canceled,Void';
        const canceledStatus = 'Canceled';
        const activatedOrNoneStatus = 'Activated,None';

        return (
            <Menu>
                {!status.includes(this.props.tripStatus) ?
                    <>
                        <MenuItem icon="delete" text="Remove Provider" id={'isDialogRemoveProvider'} onClick={this.props.handleConfirmedMenuClick} />
                        <MenuItem icon="mobile-phone" text="Send SMS" id={'isDialogSendSms'} onClick={this.props.handleConfirmedMenuClick} />
                    </>
                    : null
                }
                <MenuItem icon="arrow-right" text="Emulate Events" id={'isOverlayEmulateEvents'} onClick={this.props.handleConfirmedMenuClick} />

                {!status.includes(this.props.tripStatus) ?
                    <>
                        <MenuItem icon="confirm" text="Confirm Provider" id={'isOverlayConfirmProvider'} onClick={this.props.handleConfirmedMenuClick} />
                    </>
                    : null
                }
                {!canceledStatus.includes(this.props.tripStatus) ?
                    <MenuItem icon="undo" text="Cancel Trip" id={'isOverlayConfirmTripCancellation'} onClick={this.props.handleConfirmedMenuClick} />
                    : null
                }
                {this.props.trip !== null && !activatedOrNoneStatus.includes(this.props.trip.willCallStatus) ?
                    <MenuItem icon="phone" text="Activate Willcall" id={'isOverlayWillcall'} onClick={this.props.handleConfirmedMenuClick} />
                    : null
                }
            </Menu >
        );
    }
}

export default MenuTripSearch;
